module.exports = "/images/BG_Book_Now.png?c4507308aa79a3fe1fab4aef52fc6cea";